import { Injectable, signal } from '@angular/core';
import { BiddingModel, BiddingSessionModel } from '@core/Models/bidding.model';
import { ExhibitorModel } from '@core/Models/exhibitor.model';
import { SessionOldModel } from '@core/Models/sessionOld.model';

@Injectable({
  providedIn: 'root'
})
export class ListenerService {

  public ksmProvince = signal<any | null>(null);
  public ksmCity = signal<any | null>(null);
  public solusiexhibitor = signal<ExhibitorModel | null>(null);
  public solusiType = signal<string | null>(null);
  public solusiExhibitorId = signal<string | null>(null);
  public virtualBidding = signal<BiddingModel | null>(null);
  public biddingSession = signal<BiddingSessionModel | null>(null);
  public biddingSessionID = signal<any | null>(null);
  public openLiveChat = signal<boolean | null>(null);
  public showScrollUp = signal<boolean | null>(false);
  public liveChatExhibitor = signal<ExhibitorModel | null>({} as ExhibitorModel);
  public liveChatType = signal<string | null>(null);
  public liveChatData = signal<any | null>(null);
  public liveSession = signal<SessionOldModel | null>(null);

  public solusiMainList = signal<ExhibitorModel[] | null>([]);

  public KSMLastSearch = signal<ExhibitorModel[] | null>([]);

  public KSMBrandNow = signal<ExhibitorModel | null>(null);

  public iframeBackRoute = signal<String | null>(null);

  public currentSection = signal<any>(null);
  public sidebarSelected = signal<any>(null);

constructor() { }

}
